import DashboardHeader from "../../headers/DashboardHeader";
import EmailIcon from "@mui/icons-material/Email";
import LanguageIcon from "@mui/icons-material/Language";
import SmsIcon from "@mui/icons-material/Sms";
import PhoneInTalkIcon from "@mui/icons-material/PhoneInTalk";
import FacebookIcon from "@mui/icons-material/Facebook";
import TwitterIcon from "@mui/icons-material/Twitter";
import InstagramIcon from "@mui/icons-material/Instagram";
import { useState } from "react";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Button, IconButton } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { ArrowBack as ArrowBackIcon } from "@mui/icons-material";

export default function SupportPage() {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState("faq");
  const [expandedFaq, setExpandedFaq] = useState(null);

  // Example FAQs for your portal
  const faqs = [
    {
      q: "What is Little Haiti Global Client Portal?",
      a: "It is an online platform for managing your applications, payments, and profile for Little Haiti Global services.",
    },
    {
      q: "How do I reset my password?",
      a: "Go to the login page and click 'Forgot Password'. Follow the instructions sent to your registered email.",
    },
    {
      q: "How can I contact support?",
      a: "Use the Contact Us tab to reach our support team via email, phone, or WhatsApp.",
    },
    {
      q: "Where can I track my application status?",
      a: "Log in and go to the Dashboard. Your application status is shown there.",
    },
  ];

  const contacts = [
    {
      icon: <EmailIcon style={{ fontSize: 40, color: "#15978a" }} />,
      label: "Email",
      value: "support@littlehaitiglobal.com",
      link: "https://mail.google.com/mail/?view=cm&fs=1&to=support@littlehaitiglobal.com",
    },
    // {
    //   icon: <PhoneInTalkIcon style={{ fontSize: 40, color: "#15978a" }} />,
    //   label: "Phone",
    //   value: "+1-305-555-1234",
    //   link: "tel:+13055551234",
    // },
    {
      icon: <LanguageIcon style={{ fontSize: 40, color: "#15978a" }} />,
      label: "Website",
      value: "www.littlehaitiglobal.com",
      link: "https://www.littlehaitiglobal.com",
    },
  ];

  const socials = [
    {
      icon: <TwitterIcon style={{ fontSize: 32, color: "#40a1e3" }} />,
      label: "@LittleHaitiGlobal",
    },
    {
      icon: <FacebookIcon style={{ fontSize: 32, color: "#3b5998" }} />,
      label: "LittleHaitiGlobal",
    },
    {
      icon: <InstagramIcon style={{ fontSize: 32, color: "#e4405f" }} />,
      label: "littlehaitiglobal",
    },
  ];

  return (
    <div
      style={{
        minHeight: "100vh",
        width: "100%",
      }}
    >
      <div className="header-container">
        <DashboardHeader />
      </div>
      <div className="container">
        <div className="text-center mt-3 d-flex flex-wrap justify-content-between">
          <div>
            <IconButton onClick={() => navigate("/dashboard")}>
              <ArrowBackIcon sx={{ fontSize: 20, color: "#15978a" }} />
            </IconButton>
          </div>
          <div>
            <h2 className="primary-color mb-2">
              Support & Contact Information
            </h2>
            <p className="mb-3">We're here to help you with all your needs</p>
          </div>
          <div></div>
        </div>

        <div
          className="tabs"
          style={{
            display: "flex",
            margin: "0 auto",
            maxWidth: 500,
            background: "#fff",
            borderRadius: "15px",
            padding: "6px",
            boxShadow: "0 5px 20px rgba(0,0,0,0.1)",
          }}
        >
          <button
            className={`tab${activeTab === "faq" ? " active" : ""}`}
            style={{
              flex: 1,
              padding: "10px",
              margin: "0 2px",
              fontWeight: 600,
              border: "none",
              borderRadius: "12px",
              background: activeTab === "faq" ? "#15978a" : "transparent",
              color: activeTab === "faq" ? "#fff" : "#666",
              transition: "all 0.25s ease",
              cursor: "pointer",
              fontSize: "16px",
              transform: activeTab === "faq" ? "scale(1.02)" : "scale(1)",
              boxShadow:
                activeTab === "faq"
                  ? "0 5px 15px rgba(21, 151, 138, 0.4)"
                  : "none",
            }}
            onClick={() => setActiveTab("faq")}
            onMouseOver={(e) => {
              if (activeTab !== "faq") {
                e.target.style.background = "#f5f5f5";
                e.target.style.transform = "scale(1.02)";
              }
            }}
            onMouseOut={(e) => {
              if (activeTab !== "faq") {
                e.target.style.background = "transparent";
                e.target.style.transform = "scale(1)";
              }
            }}
          >
            FAQs
          </button>

          <button
            className={`tab${activeTab === "contact" ? " active" : ""}`}
            style={{
              flex: 1,
              padding: "10px",
              margin: "0 2px",
              fontWeight: 600,
              border: "none",
              borderRadius: "12px",
              background: activeTab === "contact" ? "#15978a" : "transparent",
              color: activeTab === "contact" ? "#fff" : "#666",
              transition: "all 0.25s ease",
              cursor: "pointer",
              fontSize: "16px",
              transform: activeTab === "contact" ? "scale(1.02)" : "scale(1)",
              boxShadow:
                activeTab === "contact"
                  ? "0 5px 15px rgba(21, 151, 138, 0.4)"
                  : "none",
            }}
            onClick={() => setActiveTab("contact")}
            onMouseOver={(e) => {
              if (activeTab !== "contact") {
                e.target.style.background = "#f5f5f5";
                e.target.style.transform = "scale(1.02)";
              }
            }}
            onMouseOut={(e) => {
              if (activeTab !== "contact") {
                e.target.style.background = "transparent";
                e.target.style.transform = "scale(1)";
              }
            }}
          >
            Contact Us
          </button>
        </div>
        <div
          className="tab-content"
          style={{
            background: "#fff",
            borderRadius: "20px",
            boxShadow: "0 10px 40px rgba(0,0,0,0.1)",
            width: "100%",
            margin: "20px auto 40px",
            padding: "40px 30px",
            transform: "translateY(0)",
            transition: "all 0.4s ease",
          }}
        >
          {activeTab === "faq" && (
            <div>
              <h3 className="mb-0 primary-color">General Information</h3>
              <p className="mb-4">
                Incase you don’t find your answer below, you can always contact
                us.
              </p>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "12px",
                }}
              >
                {faqs.map((faq, idx) => (
                  <div
                    key={idx}
                    style={{
                      background: expandedFaq === idx ? "#f0f8ff" : "#f5f7fa",
                      borderRadius: "8px",
                      boxShadow:
                        expandedFaq === idx
                          ? "0 4px 12px rgba(21, 151, 138, 0.2)"
                          : "0 1px 4px #eee",
                      transition: "all 0.3s ease",
                      transform:
                        expandedFaq === idx
                          ? "translateY(-2px)"
                          : "translateY(0)",
                      border:
                        expandedFaq === idx
                          ? "1px solid #15978a"
                          : "1px solid transparent",
                    }}
                  >
                    <button
                      style={{
                        width: "100%",
                        background: "none",
                        border: "none",
                        textAlign: "left",
                        padding: "16px 20px",
                        fontWeight: 600,
                        color: "#15978a",
                        fontSize: "16px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        cursor: "pointer",
                      }}
                      onClick={() =>
                        setExpandedFaq(expandedFaq === idx ? null : idx)
                      }
                      aria-expanded={expandedFaq === idx}
                    >
                      {faq.q}
                      <ExpandMoreIcon
                        style={{
                          transform:
                            expandedFaq === idx
                              ? "rotate(180deg)"
                              : "rotate(0deg)",
                          transition: "0.2s",
                        }}
                      />
                    </button>
                    <div
                      style={{
                        maxHeight: expandedFaq === idx ? "200px" : "0",
                        overflow: "hidden",
                        transition: "all 0.4s cubic-bezier(0.4, 0, 0.2, 1)",
                        opacity: expandedFaq === idx ? 1 : 0,
                      }}
                    >
                      <div
                        style={{
                          margin: "0 20px 16px 20px",
                          color: "#333",
                          transform:
                            expandedFaq === idx
                              ? "translateY(0)"
                              : "translateY(-10px)",
                          transition: "all 0.3s ease 0.1s",
                        }}
                      >
                        {faq.a}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}
          {activeTab === "contact" && (
            <div>
              <h3 className="mb-0 primary-color"> Contact Us</h3>
              <p className="mb-4">
                Depending on your needs, you can contact LHG support in a
                variety of ways.
              </p>

              <div
                className="contact-cards"
                style={{
                  display: "flex",
                  gap: "24px",
                  flexWrap: "wrap",
                  justifyContent: "center",
                }}
              >
                {contacts.map((c, idx) => (
                  <div
                    className="contact-card"
                    key={idx}
                    style={{
                      flex: "1 1 220px",
                      minWidth: 220,
                      maxWidth: 420,
                      background: "#f5f7fa",
                      borderRadius: "10px",
                      boxShadow: "0 2px 8px #eee",
                      padding: "20px",
                      textAlign: "center",
                      marginBottom: "12px",
                    }}
                  >
                    <div className="contact-icon">{c.icon}</div>
                    <h4 style={{ marginTop: "10px" }}>{c.label}</h4>
                    <Button
                      variant="outlined"
                      style={{
                        marginTop: "8px",
                        textTransform: "none",
                        width: "100%",
                      }}
                      component="a"
                      href={c.link}
                      target="_blank"
                    >
                      {c.value}
                    </Button>
                  </div>
                ))}
              </div>
              {/* <h3 style={{ marginTop: "10px", color: "#15978a" }}>
                Follow Us.
              </h3>
              <div
                className="social-row"
                style={{
                  display: "flex",
                  gap: "30px",
                  marginTop: "20px",
                  justifyContent: "center",
                  flexWrap: "wrap",
                }}
              >
                {socials.map((s, idx) => (
                  <div
                    className="social-item"
                    key={idx}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "10px",
                      marginBottom: "10px",
                    }}
                  >
                    {s.icon}
                    <span style={{ fontWeight: 500 }}>{s.label}</span>
                  </div>
                ))}
              </div> */}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
